import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {CheckCircle} from '@mui/icons-material';
import {Box, FormControlLabel, Radio, RadioGroup} from '@mui/material';

import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import {greenColors, orangeColors} from '../../layouts/theme/designSystem';
import {SUPPORTED_LANGUAGES} from '../../lib/constants';

export default function LanguageSwitcher() {
  const {t, i18n} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const handleSettingClick = (language: string) => {
    changeLanguage(language);
  };

  return (
    <Box
      sx={{
        backgroundColor: orangeColors[7],
        borderRadius: '8px',
        padding: '16px',
      }}
    >
      <RadioGroup
        value={currentLanguage}
        onChange={(e) => {
          handleSettingClick(e.target.value);
        }}
      >
        {SUPPORTED_LANGUAGES.map((entry) => {
          return (
            <FormControlLabel
              key={entry.id}
              value={entry.id}
              control={<Radio checkedIcon={<CheckCircle sx={{color: greenColors[700]}} />} />}
              label={t(`shared.languages.${entry.id}`)}
            />
          );
        })}
      </RadioGroup>
    </Box>
  );
}
